import * as types from "./types"
import http from "@/utils/http"
// 轻提示
import { Toast } from 'vant';

let state = {
  allLoad: false, // 加载完成
  isLoad: true, // 正在加载
  noData: false, // 暂无数据
  pageSize: 10,
  page: 0,
  data: {},
  dataList: [],
  parkInfo: {},
  deviceInfo: {},
  appWebSock: null,
  appWebSockState: false,
  discernRecord: null,
  logInfo: []
}
let actions = {
  [types.PARKLIST] (context, params) {
    state.page += 1
    state.isLoad = true
    http.post('p-ypt-parking-query', { page: state.page, pageSize: state.pageSize, name: params.name }).then(data => {
      context.commit(types.DATAPAGE, data)
      state.isLoad = false
    })
  },
  [types.WECHATUSERADD] (context, params) {
    http.post('p-app-wechat-user-add', params).then(data => {
    })
  },
  [types.WECHATUSERDELET] (context, params) {
    http.post('p-app-wechat-user-delete', params).then(data => {
    })
  },
  [types.WECHATUSERUPDATE] (context, params) {
    http.post('p-app-wechat-user-update', params).then(data => {
    })
  },
  [types.WECHATUSERQUERY] (context, params) {
    http.post('p-app-wechat-user-query', params).then(data => {
      state.data = data
    })
  },
  [types.DISCERNRECORD] (context, params) {
    http.post('p-app-discern-record', params).then(data => {
      if(!state.discernRecord || (state.discernRecord && state.discernRecord.discernTime <= data.data.discernTime)){
        state.discernRecord = data.data
      }
    })
  },

}
let mutations = {

  [types.DATAPAGE] (state, data) {
    if (data.code==='ok') {
      let index = data.data
      if (index.totalPage !== 0) { // 进行分页
        if (index.dataList.length >= 1) {
          state.dataList = state.dataList.concat(index.dataList)
        } else {
          state.allLoad = true
        }
      } else { // 暂无数据
        state.noData = true
      }
    } else {
      Toast(data.message)
    }
  },
  // 改变分页加载状态 => 正在加载
  CHANGELOAFDSTATUS (state, data) {
    state.isLoad = data.isLoad
  },
  // 重置参数设备列表 分页参数
  RESETPARAMS (state, data) {
    state.page = 0
    state.totalPage = 0
    state.noData = false
    state.allLoad = false
    state.isLoad = true
    state.dataList = []
  },
  // 设置全部加载完成
  ALLLOAD (state) {
    state.allLoad = true
    state.isLoad = false
  },
  setParkInfo (state,data) {
    state.parkInfo  = data
    console.log('-----------parkInfo-------------',data)
    localStorage.setItem("parkId", data.id);
    localStorage.setItem("parkCode", data.parkCoding);
    localStorage.setItem("parkName", data.name);
    localStorage.setItem("deptId", data.deptId);
    localStorage.setItem("parkPic", data.parkPic);
  },
  setWebSocket(state, data) {
    state.appWebSockState = true
    state.appWebSock = data
  },
  discernRecordSend(state, data) {
    state.discernRecord = data
  },
  logSend(state, data) {
    state.logInfo.unshift(data)
  },
  delSendLog(state, data) {
    state.logInfo = []
  },
}


export default { state, actions, mutations }



// WEBPACK FOOTER //
// ./src/store/app/park/index.js